export default {
  loading: false,
  error: false,
  overviewData: []
}
